import { render } from "./ModalCustomization.vue?vue&type=template&id=13bd8312&scoped=true"
import script from "./ModalCustomization.vue?vue&type=script&lang=js"
export * from "./ModalCustomization.vue?vue&type=script&lang=js"

import "./ModalCustomization.vue?vue&type=style&index=0&id=13bd8312&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bd8312"]])

export default __exports__